import React from "react";

const HomePricing = ({ inPagePricing }) => {
  return (
    <section
      className="py-20 xl:py-24 bg-white bg-center"
      style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
    >
      <div className="container">
        <div className="text-center">
          <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100 font-medium uppercase rounded-full">
            价格方案
          </span>
          {inPagePricing ? (
            <h1 className="mb-4 text-2xl md:text-3xl !leading-tight text-slate-800 font-bold tracking-tight">
              灵活的价格方案，满足不同需求
            </h1>
          ) : (
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight text-slate-800 font-bold tracking-tight">
              灵活的价格方案，满足不同需求
            </h2>
          )}

          <p className="mb-12 text-base md:text-lg text-slate-500">
            根据您的产品规模和需求，选择适合的价格方案
          </p>
        </div>
        <div className="flex flex-wrap justify-center -mx-4">
          <div className="w-full md:w-1/2 lg:w-1/3 p-4">
            <div className="flex flex-col pt-8 pb-8 bg-slate-50 rounded-md shadow-lg shadow-gray-200 hover:scale-105 transition duration-500">
              <div className="px-8 pb-8">
                <h3 className="mb-6 text-base md:text-lg text-slate-800 font-medium">
                  基础版
                </h3>
                <div className="mb-6">
                  <span className="relative -top-10 right-1 text-3xl text-slate-900 font-bold">
                    $
                  </span>
                  <span className="text-6xl md:text-7xl !leading-normal text-slate-900 font-medium">
                    10
                  </span>
                  <span className="inline-block ml-1 text-slate-500 ">
                    per month
                  </span>
                </div>
                <p className="mb-6 text-slate-400">
                  适合小型产品，每日20次查询
                </p>
                <a
                  className="inline-block py-4 px-7 mb-4 w-full text-base md:text-lg !leading-6 text-white font-medium text-center bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 rounded-md shadow-sm"
                  href="#"
                >
                  Get Started
                </a>
                <a
                  className="inline-block py-3 px-7 w-full text-slate-500 font-medium text-center bg-white hover:bg-slate-100 focus:ring-2 focus:ring-slate-100 focus:ring-opacity-50 rounded-md shadow-sm"
                  href="#"
                >
                  了解更多
                </a>
              </div>
              <div className="border-b border-slate-100"></div>
              <ul className="self-start px-8 pt-8">
                <li className="flex items-center mb-3 text-slate-500 font-medium">
                  <svg
                    className="mr-3 w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <span>完整的开发文档</span>
                </li>
                <li className="flex items-center mb-3 text-slate-500 font-medium">
                  <svg
                    className="mr-3 w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <span>AI智能分析</span>
                </li>
                <li className="flex items-center mb-3 text-slate-500 font-medium">
                  <svg
                    className="mr-3 w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <span>实时数据分析</span>
                </li>
                <li className="flex items-center text-slate-500 font-medium">
                  <svg
                    className="mr-3 w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <span>智能安全防护</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 p-4">
            <div className="flex flex-col pt-8 pb-8 bg-slate-50 rounded-md shadow-lg shadow-gray-200 hover:scale-105 transition duration-500">
              <div className="px-8 pb-8">
                <div className="flex flex-wrap items-center justify-between mb-6">
                  <h3 className="mr-3 text-base md:text-lg text-slate-800 font-medium">
                    标准版
                  </h3>
                  <span className="inline-block py-px px-2 text-xs leading-5 text-white bg-blue-600 font-medium uppercase rounded-full">
                    热门推荐
                  </span>
                </div>
                <div className="mb-6">
                  <span className="relative -top-10 right-1 text-3xl text-slate-900 font-bold">
                    $
                  </span>
                  <span className="text-6xl md:text-7xl !leading-normal text-slate-900 font-medium">
                    99
                  </span>
                  <span className="inline-block ml-1 text-slate-500 ">
                    per month
                  </span>
                </div>
                <p className="mb-6 text-slate-400">适合中型产品，无限次查询</p>
                <a
                  className="inline-block py-4 px-7 mb-4 w-full text-base md:text-lg !leading-6 text-white font-medium text-center bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 rounded-md shadow-sm"
                  href="#"
                >
                  Get Started
                </a>
                <a
                  className="inline-block py-3 px-7 w-full text-slate-500 font-medium text-center bg-white hover:bg-slate-100 focus:ring-2 focus:ring-slate-100 focus:ring-opacity-50 rounded-md shadow-sm"
                  href="#"
                >
                  了解更多
                </a>
              </div>
              <div className="border-b border-slate-100"></div>
              <ul className="self-start px-8 pt-8">
                <li className="flex items-center mb-3 text-slate-500 font-medium">
                  <svg
                    className="mr-3 w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <span>完整的开发文档</span>
                </li>
                <li className="flex items-center mb-3 text-slate-500 font-medium">
                  <svg
                    className="mr-3 w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <span>AI智能分析</span>
                </li>
                <li className="flex items-center mb-3 text-slate-500 font-medium">
                  <svg
                    className="mr-3 w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <span>实时数据分析</span>
                </li>
                <li className="flex items-center text-slate-500 font-medium">
                  <svg
                    className="mr-3 w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <span>智能安全防护</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 p-4">
            <div className="flex flex-col pt-8 pb-8 bg-slate-50 rounded-md shadow-lg shadow-gray-200 hover:scale-105 transition duration-500">
              <div className="px-8 pb-8">
                <h3 className="mb-6 text-base md:text-lg text-slate-800 font-medium">
                  企业版
                </h3>
                <div className="mb-6">
                  <span className="relative -top-10 right-1 text-3xl text-slate-900 font-bold">
                    $
                  </span>
                  <span className="text-6xl md:text-7xl !leading-normal	 text-slate-900 font-medium">
                    799
                  </span>
                  <span className="inline-block ml-1 text-slate-500 ">
                    per year
                  </span>
                </div>
                <p className="mb-6 text-slate-400">适合大型产品，无限次查询</p>
                <a
                  className="inline-block py-4 px-7 mb-4 w-full text-base md:text-lg !leading-6 text-white font-medium text-center bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 rounded-md shadow-sm"
                  href="#"
                >
                  Get Started
                </a>
                <a
                  className="inline-block py-3 px-7 w-full text-slate-500 font-medium text-center bg-white hover:bg-slate-100 focus:ring-2 focus:ring-slate-100 focus:ring-opacity-50 rounded-md shadow-sm"
                  href="#"
                >
                  了解更多
                </a>
              </div>
              <div className="border-b border-slate-100"></div>
              <ul className="self-start px-8 pt-8">
                <li className="flex items-center mb-3 text-slate-500 font-medium">
                  <svg
                    className="mr-3 w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <span>完整的开发文档</span>
                </li>
                <li className="flex items-center mb-3 text-slate-500 font-medium">
                  <svg
                    className="mr-3 w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <span>AI智能分析</span>
                </li>
                <li className="flex items-center mb-3 text-slate-500 font-medium">
                  <svg
                    className="mr-3 w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <span>实时数据分析</span>
                </li>
                <li className="flex items-center text-slate-500 font-medium">
                  <svg
                    className="mr-3 w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <span>智能安全防护</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomePricing;
